import {cn} from 'platform/shared-tw';

import type {PartOperationVariant} from './CarPartModal.types';
import type {PartIllustrationComponent} from './partIllustrations';

const VARIANT_BG: Record<PartOperationVariant | 'default', string> = {
  damage: 'bg-(--color-mira-damage-bg-light)',
  service: 'bg-(--color-mira-service-bg-light)',
  suggestions: 'bg-(--color-mira-suggestions-bg-light)',
  default: 'bg-(--color-mira-gray-5)',
};

export interface PartIllustrationProps {
  readonly Illustration: PartIllustrationComponent;
  readonly variant: PartOperationVariant | null;
}

export function PartIllustration(props: PartIllustrationProps) {
  const bgClass = VARIANT_BG[props.variant ?? 'default'];
  const Illustration = props.Illustration;

  return (
    <div
      className={cn(
        'relative flex h-32 w-full items-center justify-center overflow-hidden rounded-2xl px-6 py-3',
        bgClass
      )}
    >
      <Illustration mode="standalone" />
    </div>
  );
}
